import React from 'react';
import Modal from 'react-modal';
import { useCookies } from 'react-cookie';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import EditorString from '../Components/EditorString/EditorString';

const customStyles = {
  content: {
    background: 'none',
    padding: 0,
    border: 'none',
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.8)',
    zIndex: 2003,
  },
};

const StartPageSelectorModal = (props) => {
  const [_, setCookie] = useCookies([]);

  function handleClick(e, startPageCookieValue) {
    e.preventDefault();
    setCookie('sp', startPageCookieValue, {path: '/', maxAge: 31536000});
    window.location.href = `${props.currentRegionUrl}`;
  }

  return (
    <Modal
      ariaHideApp={false}
      isOpen={true}
      style={customStyles}
      shouldCloseOnOverlayClick={false}
    >
      <div className="mx-0 bg-white text-center lg:mx-[20%] 3xl:mx-[33%]">
        <EditorString value={props.text?.value} />
        <div className="flex flex-col justify-center gap-4 bg-black px-5 py-7 md:flex-row">
          <a
            href={`${props.currentRegionUrl}`}
            onClick={(e) => handleClick(e, 'ce')}
            className="btn btn--outline-white btn--large w-full max-w-xs self-center uppercase"
          >
            {props.consumerElectronicText}
          </a>
          <a
            href={`${props.currentRegionUrl}`}
            onClick={(e) => handleClick(e, 'pm')}
            className="btn btn--outline-white btn--large w-full max-w-xs self-center uppercase"
          >
            {props.proMediaSolutionsText}
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default StartPageSelectorModal;
